export default __webpack_public_path__ + "sprite_dark.470fcdeb2c9cbd847091faa1c4e15389.svg";